import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { ARMAZEM_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    ARMAZEM_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    ARMAZEM_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [ARMAZEM_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [ARMAZEM_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [ARMAZEM_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [ARMAZEM_ENDPOINT],
    id
  );
}
